export const defineSelectorFactory = (definition) => definition;
export const defineSelectorResultFunction = (definition) => definition;
